export default {
  studiesLimit: 10,
  analysesLimit: 10,
  notificationsLimit: 10,
  dropboxFilesRequestLimit: 200,
  dropboxFilesLoadingLimit: 25,
  dropboxPagesLimit: 10,
};
